import { render } from "./UploadProductChangeDropTarget.vue?vue&type=template&id=68f875c2"
import script from "./UploadProductChangeDropTarget.vue?vue&type=script&lang=ts"
export * from "./UploadProductChangeDropTarget.vue?vue&type=script&lang=ts"
script.render = render

export default script